import * as React from 'react';
import { Value } from 'app/types-shared';

interface TooltipDataProps {
  data: Value[];
  renderIcon: boolean;
  applicationUrl: string;
}

const TooltipDataElement = ({ value, icon }) => icon
  ? <img src={icon} title={value} />
  : value ?? '';

export const TooltipData: React.FC<TooltipDataProps> = ({ data, renderIcon, applicationUrl }) => {

  if (!data || data.length === 0) {
    return null;
  }
  const iconUrl = (icon: string) =>{
    return (applicationUrl.endsWith('/') ? applicationUrl : applicationUrl + '/') + icon;
  } ;

  if (data.length === 1) {
    
    return <TooltipDataElement
      value={data[0].d ?? data[0].v}
      icon={renderIcon && data[0].i && iconUrl(data[0].i)}
    />;
  }

  return <ul>
    {data.map((field, index) => <li key={index}>
      <TooltipDataElement
        value={field.d ?? data[0].v}
        icon={renderIcon && field.i && iconUrl(field.i)}
      />;
    </li>)}
  </ul>;
};
